import * as React from "react"
import {Fragment, useEffect} from "react";
import {useNavigate} from "react-router-dom";

import {useAppDispatch, useAppSelector} from "../../redux/storeHooks";
import {clearEbooks, fetchEbooks, setEBooksPaginationPage} from "./eLibrarySlice";
import Loader from "../ui/Loader";
import EBookItem from "./EBookItem";
import Pagination from "../ui/Pagination";


const LibraryPage = () => {

  const dispatch = useAppDispatch();
  const {eBooks, eBooksStatus, pagination} = useAppSelector((store) => store.eLibraryState);
  const {currentPage, postsPerPage} = pagination;

  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchEbooks({navigate, currentPage, postsPerPage}));
  }, [dispatch, navigate, currentPage, postsPerPage]);

  useEffect(() => {
    return () => {
      dispatch(clearEbooks())
    }
  }, [dispatch]);

  const setPaginationStep = (currentPage: number) => {
    dispatch(setEBooksPaginationPage(currentPage))
  }

  return (
    <section className="section">
      <div className="container">
        <span className="block h5 text-center red2">Electronic Library</span>
        <h2 className="h2 text-center black max-420 auto">List Of Ebooks</h2>
        <p className="margin-b-30 max-760 auto text-center">
          We've curated a selection of books tailored to your interests. These exceptional tutorials, crafted by a team of experts, are designed to empower you in effortlessly acquiring new skills for harnessing the potential of the social media platform Instagram.        </p>
        {eBooks.length ? (
          <Fragment>
            <ul className="member-books flex flex--wrap flex--top fix-ul">
              {eBooks.map(eBook => <EBookItem key={eBook.title} eBook={eBook}/>)}
            </ul>
            <Pagination pagination={pagination} setPaginationStep={setPaginationStep}/>
            {eBooksStatus === "loading" ? (
              <div className="overlay overlay--visible">
                <Loader className={"member-loader--white"}/>
              </div>
            ) : null}
          </Fragment>
        ) : (eBooksStatus === "loading") ? (
          <div className="min-h-500 relative">
            <Loader/>
          </div>
        ) : (
          <p className="margin-b-30 max-520 auto text-center">
            No books found, please contact administrator
          </p>
        )}
      </div>
    </section>
  )
}

export default LibraryPage
